import { appendMonthYear } from '@/app/utils/appendMonthYear';
import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { GetServerSidePropsContext } from 'next';
import React from 'react';
import { DynamicPageDataProps, getDynamicPageData } from 'utils/getDynamicPageData';

import { DynamicPage } from 'components/CMS/DynamicPage';

const Doctors = ({ data, pageData }: DynamicPageData) => {
  return <DynamicPage data={data} pageData={pageData} />;
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<DynamicPageDataProps> {
  const { query } = context;
  const { slug } = query;
  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.Doctors, context, slug as string);

  if (error) {
    return { notFound: true, props: { error } };
  }

  if (pageData?.meta_title) {
    pageData.meta_title = appendMonthYear(pageData.meta_title);
  }

  if (pageData?.redirect_url) {
    const { res } = context;
    if (res) {
      res.writeHead(301, { Location: pageData.redirect_url });
      res.end();
    }
  }

  return { props: { data: modules, pageData } };
}

export default Doctors;
